import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, E = ({ size: e = 16, useVw: l, useRem: o, color: c, withColor: n, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-yubibao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ä½å¸å®"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: n ? r(c, 0, "#262933") : "#262933",
        datafollowfill: n ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M5.4 16c0-5.854 4.746-10.6 10.6-10.6 1.578 0 3.073.344 4.416.96a.9.9 0 0 0 .751-1.635A12.358 12.358 0 0 0 16 3.6C9.152 3.6 3.6 9.152 3.6 16c0 6.848 5.552 12.4 12.4 12.4 6.848 0 12.4-5.552 12.4-12.4V8.768c0-.949-1.128-1.446-1.828-.805l-3.872 3.54a.9.9 0 0 0 1.215 1.328l2.685-2.455V16c0 5.854-4.746 10.6-10.6 10.6-5.854 0-10.6-4.746-10.6-10.6Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.943 11.666a2.003 2.003 0 0 1 2.833 0l2.917 2.918c.782.782.782 2.05 0 2.832l-2.917 2.918a2.003 2.003 0 0 1-2.833 0l-2.917-2.918a2.003 2.003 0 0 1 0-2.832l2.917-2.918Zm1.56 1.273 2.917 2.918c.08.079.08.207 0 .287l-2.917 2.917a.203.203 0 0 1-.287 0l-2.917-2.917a.203.203 0 0 1 0-.287l2.917-2.918a.203.203 0 0 1 .287 0Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, u = E;
export {
  u as default
};
